module.exports = __webpack_public_path__ + "img/img-tips.cb0f1dd.png";